import React, {lazy, useEffect, useRef, useState} from 'react';
import './WelcomePage.css'
import '../../i18n'
import {useTranslation} from "react-i18next";
import appstore from "../../assets/img/store_badges/appstore.webp"
import googleplay from "../../assets/img/store_badges/googleplay.webp"
import mockup1 from "../../assets/img/mockup1.webp"
import mockup2 from "../../assets/img/mockup2.webp"
import mockup3 from "../../assets/img/mockups/Group-1change.webp"
import mockup4 from "../../assets/img/mockups/Group-2change.webp"
import image11 from "../../assets/img/car_image.png"

import appstoretrawhite from "../../assets/img/store_badges/appstore-tra-white.webp"
import googleplaytrawhite from "../../assets/img/store_badges/googleplay-tra-white.webp"
import chromewhite from "../../assets/img/store_badges/extension_icon-removebg-preview.webp"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowRightToBracket} from '@fortawesome/free-solid-svg-icons'
import 'react-bootstrap'
import {useLocation, useNavigate} from "react-router-dom";
import Login from "../../Api/Login";
import {useSelector} from "react-redux";
import Footer from "../../Components/Footer/Footer";
import extension from "../../assets/img/store_badges/extension_icon.webp";
import {Dropdown} from "react-bootstrap";
import i18n from "i18next";
import changeLanguage from '../../Api/ChangeLanguage'



const WelcomePage = () => {
    const {t} = useTranslation()
    const user_is_auth = useSelector(state => state.user_is_auth)
    const navigate = useNavigate()
    let redirectUrl
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const [isScrolled, setIsScrolled] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);
    const pageRef = useRef(null)
    const faqs = useRef(null)
    const heroRef = useRef(null)
    const content1 = useRef(null)
    const location = useLocation()
    const {state} = location

    if (process.env.NODE_ENV === 'production') {
        redirectUrl = i18n.language==="en"? `${process.env.REACT_APP_PROD_LINK}todo` :`${process.env.REACT_APP_PROD_LINK}${i18n.language}/todo`
    } else {
        redirectUrl = i18n.language==="en"? `${process.env.REACT_APP_DEV_LINK}todo`:`${process.env.REACT_APP_DEV_LINK}${i18n.language}/todo`
    }

    const handleLogin = async () => {
        const url = await Login(redirectUrl)
        try {
            window.open(url, '_self')
        } catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        setSelectedLanguage(i18n.language)
        const handleScroll = () => {
            if (window.innerWidth > 992) {
                setIsScrolled(window.pageYOffset > 0)
            }
        }
        const handleResize = () => {
            if (window.innerWidth > 992) {
                setIsOpen(false)
            }

        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const languageTranslations = {
        en: 'English',
        ru: 'Русский',
        uk: 'Українська',
    };
    useEffect(() => {
        return () => {
            if (pageRef.current) {
                pageRef.current.scrollIntoView({behavior: 'smooth'})
            }
            console.log('state && state.id', state && state.id)
            if (state && state.id === '#content-1' && content1.current) {
                content1.current.scrollIntoView({behavior: 'smooth'})
            } else if (state && state.id === '#hero-6' && heroRef.current) {
                heroRef.current.scrollIntoView({behavior: 'smooth'})
            } else if (state && state.id === '#faqs-1' && faqs.current) {
                faqs.current.scrollIntoView({behavior: 'smooth'})
            }
        }
    }, [state?.id])

    // const changeLanguages = (language) => {
    //     const currentUrl = window.location.href;
    //     const currentLang = i18n.language;
    //
    //     // Если выбран язык "en", удаляем его из URL
    //     if (language === "en") {
    //         const newUrl = currentUrl.replace(`/${currentLang}/`, "/");
    //         window.history.replaceState({}, document.title, newUrl);
    //     } else {
    //         // Иначе, добавляем или заменяем язык в URL
    //         const langPrefix = `/${language}/`;
    //         const newUrl =
    //             currentUrl.includes(`/${currentLang}/`)
    //                 ? currentUrl.replace(`/${currentLang}/`, langPrefix)
    //                 : langPrefix + currentUrl.replace(/^https?:\/\/[^]+/, "");
    //
    //         window.history.replaceState({}, document.title, newUrl);
    //     }
    //
    //     i18n.changeLanguage(language);
    //     localStorage.setItem("language", language);
    // };

    // const changeLanguages = (language) => {
    //     const currentUrl = window.location.href;
    //     const currentLang = i18n.language;
    //
    //     const cleanedUrl = currentUrl.replace(`${window.location.origin}`, "");
    //
    //     const pathAfterLang = cleanedUrl.replace(`/${currentLang}/`, "");
    //
    //     const cleanedPath = pathAfterLang.replace(/^\/|\/$/g, '');
    //
    //     if (language === "en") {
    //         const newUrl = `/${cleanedPath}`;
    //         navigate(newUrl)
    //     } else {
    //         const langPrefix = `/${language}/`;
    //         const newUrl = langPrefix + cleanedPath;
    //         navigate(newUrl)
    //     }
    //
    //     i18n.changeLanguage(language);
    //     localStorage.setItem("language", language);
    // };

    return (
        <div>
            <div ref={pageRef} id="page" className="page">

                <header id='header_nav' style={window.innerWidth > 992 ?
                    {
                        backgroundColor: isScrolled ? '#333' : 'transparent',
                        paddingTop: isScrolled ? '20px' : '30px',
                        paddingBottom: isScrolled ? '20px' : '30px'
                    }
                    : (window.innerWidth < 992 && window.innerWidth > 576) ? {
                            backgroundColor: '#333',
                            padding: '20px 100px'
                        }
                        : {backgroundColor: '#333', padding: '20px 30px'}}>
                    <div className='container_nav'>
                        <a href="#" className="navbar-brand logo-black">
                            <div className='logo_navbar'>CarInspect</div>
                        </a>
                        <div className='default_container'>
                            <ul className="ul_navbar">
                                <li className="li_navbar"><a className="link_navbar"
                                                             href="#">{t("welcomePage.About")}</a></li>
                                <li className="nli_navbar" style={{position: "relative"}}
                                    onMouseEnter={() => setIsDropdownOpen(true)}
                                    onMouseLeave={() => setIsDropdownOpen(false)}>
                                    <a className="link_navbar"
                                       style={{display: 'flex', justifyContent: "center", alignItems: 'center'}}
                                       href="#content-1">{t("welcomePage.WhatWeDo")}</a>
                                </li>
                                <li className="li_navbar"><a className="link_navbar"
                                                             href="#content-9">{t("welcomePage.Screens")}</a></li>

                                <li className="li_navbar"><a className="link_navbar"
                                                             href="#faqs-1">{t("welcomePage.FAQS")}</a></li>
                            </ul>
                            <Dropdown>
                                <Dropdown.Toggle className="link_navbar custom_changeLang_btn" id="dropdown-basic">
                                    {languageTranslations[i18n.language]}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {i18n.languages.map((language) => {
                                        if (language !== i18n.language) {
                                            return (
                                                <Dropdown.Item
                                                    onClick={() => changeLanguage(language, navigate)}
                                                    key={language}
                                                    href="#"
                                                >

                                                    {languageTranslations[language]}
                                                </Dropdown.Item>
                                            );
                                        }
                                        return null;
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                            <button className={user_is_auth ? "home_btn_navbar d-flex align-items-center" : "login_btn_navbar d-flex align-items-center"}
                                    onClick={() => user_is_auth ?navigate(i18n.language==='en'?`/todo/page/1`:`/${i18n.language}/todo/page/1`) : handleLogin()}>
                                <span
                                    className="link_navbar p-0">{user_is_auth ? t("welcomePage.btnNotAuth") : t("welcomePage.btnAuth")}</span>
                                <FontAwesomeIcon icon={faArrowRightToBracket}
                                                 style={{color: "#ffffff", marginLeft: 5}}/>
                            </button>
                        </div>
                        <div className='burger_menu_container'>
                            <div id="nav-icon1" className={isOpen ? 'open' : ''} onClick={() => setIsOpen(!isOpen)}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </header>
                {isOpen && <div className='burger_menu_dropdown'>
                    <ul className='burger_menu_dropdown_ul'>
                        <li className="burger_menu_dropdown_li"><a className="link_navbar" href="#">{t("welcomePage.About")}</a></li>
                        <li className="burger_menu_dropdown_li"><a className="link_navbar" href="#content-1">{t("welcomePage.WhatWeDo")}</a></li>
                        <li className="burger_menu_dropdown_li"><a className="link_navbar" href="#content-8">{t("welcomePage.Screens")}</a>
                        </li>
                        <li className="burger_menu_dropdown_li"><a className="link_navbar" href="#faqs-1">{t("welcomePage.FAQS")}</a></li>
                        <button className={user_is_auth ? "home_btn_navbar d-flex align-items-center" : "login_btn_navbar d-flex align-items-center"}
                                onClick={() => user_is_auth ? navigate(i18n.language==='en'?`/todo/page/1`:`/${i18n.language}/todo/page/1`) : handleLogin()}>
                                <span
                                    className="link_navbar p-0">{user_is_auth ? t("welcomePage.btnNotAuth") : t("welcomePage.btnAuth")}</span>
                            <FontAwesomeIcon icon={faArrowRightToBracket}
                                             style={{color: "#ffffff", marginLeft: 5}}/>
                        </button>
                        <li className="burger_menu_dropdown_li">
                            <Dropdown>
                                <Dropdown.Toggle className="link_navbar custom_changeLang_btn" id="dropdown-basic">
                                    {languageTranslations[i18n.language]}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {i18n.languages.map((language) => {
                                        if (language !== i18n.language) {
                                            return (
                                                <Dropdown.Item
                                                    onClick={() => changeLanguage(language, navigate)}
                                                    key={language}
                                                    href="#"
                                                >
                                                    {languageTranslations[language]}
                                                </Dropdown.Item>
                                            );
                                        }
                                        return null;
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        </li>
                    </ul>
                </div>}
                <section id="hero-6" ref={heroRef} className="bg-scroll hero-section division">
                    <div className="container white-color">
                        <div className="row d-flex align-items-center">
                            <div className="col-md-6 col-lg-6">
                                <div className="hero-6-img wow fadeInUp" data-wow-delay="0.5s">
                                    <img className="img-fluid" src={mockup4} alt="hero-image"/>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6">
                                <div className="hero-txt text-right mb-40">
                                    <h2 className="wow fadeInUp" data-wow-delay="0.4s">
                                        CarInspect
                                    </h2>
                                    <h3 className="h3-xs wow fadeInUp" data-wow-delay="0.6s">
                                        {t("welcomePage.underMainText")}
                                    </h3>
                                  {/*Эффективно управляйте инспекциями автомобилей с CarInspect*/}
                                    <div className="stores-badge wow fadeInUp" data-wow-delay="0.8s">
                                        <a href="https://www.apple.com/ua/app-store/" className="store">
                                            <img className="appstore-original "
                                                 src={appstore}
                                                 width={160} height={50} alt="appstore-logo"/>
                                        </a>
                                        <a href="https://chrome.google.com/webstore/category/extensions?hl=uk"
                                           className="store">
                                            <img style={{borderRadius: 5, border: '#cecece 1px solid'}}
                                                 className="appstore-original appstore-original-custom" src={extension}
                                                 width={160}
                                                 height={50} alt="appstore-logo"/>
                                        </a>
                                        <a href="https://play.google.com/store/games?device=windows&hl=uk"
                                           className="store">
                                            <img className="googleplay-original googleplay-original-custom"
                                                 src={googleplay}
                                                 width={160} height={50} alt="googleplay-logo"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="content-1" ref={content1} className=" content-section division">
                    <div className="container">
                        <div className="row d-flex align-items-center">
                            <div className="col-md-6 col-lg-6 custom-text-align custom-margin_welcome_page">
                                <div className="content-txt">
                                    <h3 className="h3-xl wow fadeInUp" data-wow-delay="0.3s">
                                        {/*Organize all your media content with AppSet easily*/}
                                        {t("welcomePage.InspectionCreation")}
                                    </h3>
                                    <p style={{fontSize: 18}} className=" wow fadeInUp" data-wow-delay="0.5s">
                                        {t("welcomePage.InspectionCreationText")}
                                        {/*Создание инспекций: Мы предоставляем возможность создания подробных и*/}
                                        {/*структурированных инспекций автомобилей. Вы можете легко заполнять информацию о*/}
                                        {/*состоянии автомобиля, его компонентах и деталях. Мы обеспечим вас всей*/}
                                        {/*необходимой функциональностью для того, чтобы вести полный контроль над*/}
                                        {/*процессом инспекции.*/}
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-5 offset-lg-1">
                                <div className="content-img wow fadeInLeft" data-wow-delay="0.5s">
                                    <img className="img-fluid" src={mockup2} alt="content-image"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="content-5" className="content-section">
                    <div className="bg-scroll bg-inner bg-lightgrey division">
                        <div className="container">
                            <div className="row d-flex align-items-center custom-reverse">
                                <div className="col-md-6 col-xl-5">
                                    <div className="content-5-img wow fadeInRight" data-wow-delay="0.5s">
                                        <img className="img-fluid" src={mockup1} alt="content-image"/>
                                    </div>
                                </div>
                                <div className="col-md-6 col-xl-6 offset-xl-1 custom-text-align ">
                                    <div className="content-txt">
                                        <h3 className="h3-xl wow fadeInUp" data-wow-delay="0.3s">
                                            {t("welcomePage.CreateWithExtention")}
                                            {/*Создание онлайн-инспекций с помощью Google Chrome расширения*/}
                                        </h3>
                                        <p className="p-md wow fadeInUp" data-wow-delay="0.5s">
                                            {t("welcomePage.CreateWithExtentionText")}
                                            {/*Мы разработали специальное расширение для браузера Google Chrome, которое*/}
                                            {/*позволяет вам проводить инспекции онлайн с легкостью. Просто установите наше*/}
                                            {/*расширение, и вы сможете заполнять инспекционные формы прямо в браузере,*/}
                                            {/*сохранять результаты и получать доступ к ним в любое время и из любого*/}
                                            {/*места.*/}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="content-2" className="content-section division">
                    <div className="container">
                        <div className="row d-flex align-items-center">
                            <div className="col-md-6 col-lg-6 custom-text-align">
                                <div className="content-txt">
                                    <h3 className="h3-xl wow fadeInUp mg-top-main" data-wow-delay="0.3s">
                                        {/*Organize all your media content with AppSet easily*/}
                                        {t("welcomePage.TaskPlanning")}
                                    </h3>
                                    <p style={{fontSize: 18}} className=" wow fadeInUp" data-wow-delay="0.5s">
                                        {t("welcomePage.TaskPlanningText")}
                                        {/*Мы предоставляем удобный инструмент для планирования задач при проведении*/}
                                        {/*инспекций. С помощью нашего инструмента вы можете создавать задачи, задавать*/}
                                        {/*время и место их выполнения, а также связывать их с конкретными инспекциями. Это*/}
                                        {/*поможет вам организовать процесс инспекции автомобилей и не пропустить ни одну*/}
                                        {/*задачу.*/}
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-5 offset-lg-1">
                                <div className="content-img wow fadeInLeft" data-wow-delay="0.5s">
                                    <img className="img-fluid" src={mockup2} alt="content-image"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="content-9" className="content-section division pt-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center section-title">
                                <h2 className="h2-sm">   {t("welcomePage.BeautifulUI")}</h2>
                                <p className="p-lg">
                                    {t("welcomePage.BeautifulUIText")}
                                    {/*Наше приложение имеет привлекательный и удобный дизайн, который обеспечивает*/}
                                    {/*пользователям приятный и интуитивно понятный опыт использования.*/}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 text-center wow fadeInUp" data-wow-delay="0.5s">
                                <img className="img-fluid" src={mockup3} alt="content-image"/>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="content-10" className="pb-100 content-section">
                    <div className="bg-scroll pt-100 bg-inner division" style={{backgroundColor:"#128515"}}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="content-txt white-color text-center">
                                        <h3 className="h3-xl">
                                            {t("welcomePage.InspectionProcess")}
                                            {/*Процесс инспектирования становился проще.*/}
                                        </h3>
                                        <p className="p-lg">
                                            {t("welcomePage.InspectionProcessText")}
                                            {/*Наше приложение делает процесс инспектирования машин легким и приятным*/}
                                            {/*благодаря своей интуитивно понятной и простой в использовании системе. Вы*/}
                                            {/*сможете легко навигироваться по функциям приложения и проводить детальную*/}
                                            {/*проверку автомобилей без лишних хлопот. Откройте для себя удобство и*/}
                                            {/*удовольствие от инспектирования машин с нашим приложением.*/}
                                        </p>
                                    </div>
                                    <div className="content-boxes">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="cbox-1 box-icon-md wow fadeInUp"
                                                     data-wow-delay="0.3s">
                                                    <span className="green-color ti-Line-File-20"></span>
                                                    <div className="cbox-1-txt">
                                                        <h5 className="h5-sm"> {t("welcomePage.CreateYourAccount")}</h5>
                                                        <p>
                                                            {t("welcomePage.CreateYourAccountText")}
                                                            {/*Для получения полного доступа к функциональности инспекции*/}
                                                            {/*машин и сохранения результатов, рекомендуется создать*/}
                                                            {/*аккаунт. Это позволит вам сохранять и синхронизировать*/}
                                                            {/*данные между устройствами.*/}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="cbox-1 box-icon-md wow fadeInUp" data-wow-delay="0.5s">
                                                    <span className=""> <img src={image11} alt=""/></span>
                                                    <div className="cbox-1-txt">
                                                        <h5 className="h5-sm">  {t("welcomePage.CreateYourInspection")}</h5>
                                                        <p>
                                                            {t("welcomePage.CreateYourInspectionText")}
                                                            {/*Создание инспекций в нашем приложении - это просто и удобно.*/}
                                                            {/*Вы сможете легко добавлять информацию о техническом*/}
                                                            {/*состоянии автомобиля, прикреплять фотографии и делать*/}
                                                            {/*соответствующие заметки, чтобы получить полноценный отчет об*/}
                                                            {/*инспекции*/}
                                                        </p>

                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="grey-border">
                    <div className="container">
                        <div className="row">
                            <div className="col b-bottom"></div>
                        </div>
                    </div>
                </div>
                <div id="statistic-2" className="wide-60 statistic-section division">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-6 col-md-3">
                                <div className="statistic-block box-icon wow fadeInUp" data-wow-delay="0.3s">
                                    <span className="green-color ti-Line-Download-1"></span>
                                    <p className="statistic-number txt-700">3,<span
                                        className="count-element">438</span></p>
                                    <p className="txt-500">Downloads</p>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3">
                                <div className="statistic-block box-icon wow fadeInUp" data-wow-delay="0.5s">
                                    <span className="green-color ti-Line-Paper-plane"></span>
                                    <p className="statistic-number txt-700">1,<span
                                        className="count-element">263</span></p>
                                    <p className="txt-500">Tickets Closed</p>

                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3">
                                <div className="statistic-block box-icon wow fadeInUp" data-wow-delay="0.7s">
                                    <span className="green-color ti-Line-People-1"></span>
                                    <p className="statistic-number txt-700">5,<span
                                        className="count-element">172</span></p>
                                    <p className="txt-500">Followers</p>
                                </div>
                            </div>
                            <div className="col-sm-6 col-md-3">
                                <div className="statistic-block box-icon wow fadeInUp" data-wow-delay="0.9s">
                                    <span className="green-color ti-Line-Coffee-mug"></span>
                                    <p className="statistic-number txt-700">4,<span
                                        className="count-element">874</span></p>
                                    <p className="txt-500">Cups of Coffee</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section id="faqs-1" ref={faqs} style={{backgroundColor: '#f2f2f2'}}
                         className="bg-fixed wide-100 faqs-section division">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center section-title">
                                <h2 className="h2-sm"> {t("welcomePage.FrequentlyQuestions")}</h2>
                                <p className="p-lg">
                                    {/*Aliquam a augue suscipit, luctus neque purus ipsum neque dolor*/}
                                    {/*primis libero*/}
                                    {/*tempus,*/}
                                    {/*tempor posuere ligula varius*/}
                                    {t("welcomePage.FrequentlyQuestionsText")}
                                    {/*Ниже представлены ответы на некоторые из самых популярных вопросов, связанных с*/}
                                    {/*использованием нашего приложения для инспекции машин*/}
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="questions-holder ind-30">
                                    <div className="question wow fadeInUp" data-wow-delay="0.3s">
                                        <h5 className="h5-sm">
                                            {/*Lobortis sit magna ornare magna egestas?*/}
                                            {t("welcomePage.QuestionOne")}
                                            {/*Какая информация доступна в отчете об инспекции автомобиля*/}
                                        </h5>
                                        <p>
                                            {/*Etiam sit amet mauris suscipit sit amet in odio. Integer congue leo*/}
                                            {/*metus. Vitae arcu*/}
                                            {/*mollis blandit*/}
                                            {/*ultrice ligula egestas magna suscipit lectus magna suscipit luctus undo*/}
                                            {/*blandit*/}
                                            {/*vitae purus laoreet*/}
                                            {t("welcomePage.QuestionOneText")}
                                            {/*Отчет об инспекции автомобиля содержит информацию о техническом состоянии,*/}
                                            {/*пробеге, истории обслуживания, истории аварий и других важных аспектах,*/}
                                            {/*которые помогут вам сделать информированный выбор.*/}
                                        </p>
                                    </div>
                                    <div className="question wow fadeInUp" data-wow-delay="0.5s">
                                        <h5 className="h5-sm">
                                            {/*Placeat axime facere omnis volute?*/}
                                            {t("welcomePage.QuestionTwo")}
                                            {/*Могу ли я делиться отчетом инспекции?*/}
                                        </h5>
                                        <p>
                                            {/*An augue egestas an ipsum vitae emo ligula volute ante ipsum primis in*/}
                                            {/*faucibus sit*/}
                                            {/*ametn in odio.*/}
                                            {/*Integer congue leo metus, eu mollis lorem viverra suscipit lectus magna*/}
                                            {t("welcomePage.QuestionTwoText")}
                                            {/*После завершения инспекции, вы сможете поделиться отчетом или получить его*/}
                                            {/*на электронную почту, чтобы люди могли изучить его в удобное для них время.*/}
                                        </p>

                                    </div>

                                    <div className="question wow fadeInUp" data-wow-delay="0.7s">

                                        <h5 className="h5-sm">
                                            {/*Pretium purus lacus tempor an ipsum vitae augue*/}
                                            {/*egestas emo ligula?*/}
                                            {t("welcomePage.QuestionThree")}
                                            {/*Могу ли я планировать инспекции?*/}
                                        </h5>
                                        <p>
                                            {t("welcomePage.QuestionThreeText")}
                                            {/*Да, вы можете планировать инспекции в приложении. Мы предоставляем*/}
                                            {/*возможность создания расписания для инспекции автомобилей. Вы можете выбрать*/}
                                            {/*удобную дату и время, чтобы заранее запланировать осмотр конкретного*/}
                                            {/*автомобиля. Кроме того, вы также можете установить напоминания, чтобы быть*/}
                                            {/*уверенными, что не пропустите запланированную инспекцию. Планирование*/}
                                            {/*инспекций поможет вам более эффективно организовать свое время и*/}
                                            {/*гарантировать осмотр нужных автомобилей в удобное для вас время.*/}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="questions-holder ind-30">
                                    <div className="question wow fadeInUp" data-wow-delay="0.3s">
                                        <h5 className="h5-sm">
                                            {/*Aliquam dapibus pretium ornare?*/}
                                            {t("welcomePage.QuestionFour")}
                                            {/*Мои данные синхронизируются между устройствами?*/}
                                        </h5>
                                        <p>
                                            {/*Feugiat eros ligula massa lipsum primis in orci luctus et ultrices*/}
                                            {/*posuere cubilia*/}
                                            {/*curae*/}
                                            {/*congue lorem. ante ipsum primis in faucibus bibendum sit amet in odio*/}
                                            {t("welcomePage.QuestionFourText")}
                                            {/*Да, ваши данные синхронизируются между устройствами. Приложение и сайт*/}
                                            {/*работают в согласованности, чтобы обеспечить единое хранилище данных. Когда*/}
                                            {/*вы создаете аккаунт и входите в него на разных устройствах, ваши сохраненные*/}
                                            {/*объявления, отчеты об инспекции и другие данные автоматически*/}
                                            {/*синхронизируются. Это позволяет вам легко получать доступ к своим данным и*/}
                                            {/*управлять ими с любого устройства, где у вас установлено приложение или*/}
                                            {/*имеется доступ к интернету через веб-сайт.*/}
                                        </p>
                                    </div>
                                    <div className="question wow fadeInUp" data-wow-delay="0.5s">
                                        <h5 className="h5-sm">
                                            {/*An interdum lobortis pretium ornare?*/}
                                            {t("welcomePage.QuestionFive")}
                                            {/*Как я могу использовать расширение Google Chrome для быстрого сохранения объявления в приложение?*/}
                                        </h5>
                                        <p>
                                            {/*Feugiat eros, ac tincidunt ligula massa in faucibus orci luctus et*/}
                                            {/*ultrices posuere*/}
                                            {/*cubilia curae*/}

                                            {t("welcomePage.QuestionFiveText")}

                                            {/*Чтобы быстро сохранить объявление с веб-страницы в наше приложение,*/}
                                            {/*установите расширение Google Chrome. Затем, при просмотре объявления,*/}
                                            {/*выберите опцию "Создать инспекцию".*/}
                                            {/*Объявление будет автоматически добавлено в вашу коллекцию в приложении для*/}
                                            {/*дальнейшего просмотра и инспекции.*/}
                                        </p>
                                    </div>
                                    <div className="question wow fadeInUp" data-wow-delay="0.7s">

                                        <h5 className="h5-sm">
                                            {/*Dapibus lobortis pretium ornare?*/}
                                            {t("welcomePage.QuestionSix")}
                                            {/*Что делать, если у меня возникнут вопросы или проблемы при использовании приложения?*/}
                                        </h5>
                                        <p>
                                            {/*Praesent semper, lacus sed cursus porta,feugiat primis in faucibus orci*/}
                                            {/*luctus tincidunt ligula*/}
                                            {/*ultrice sapien egestas lobortis magna*/}
                                            {t("welcomePage.QuestionSixText")}
                                            {/*Мы предлагаем поддержку пользователей, готовых помочь вам с любыми вопросами*/}
                                            {/*или проблемами. Вы можете связаться с нами через нашу службу поддержки, и мы*/}
                                            {/*постараемся решить все ваши вопросы в кратчайшие сроки.*/}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 text-center">
                            </div>
                        </div>


                    </div>
                </section>
                <section id="download-2" className="bg-scroll bg-image wide-100 download-section division">
                    <div className="container white-color">
                        <div className="row">


                            <div className="col-lg-10 offset-lg-1">
                                <div className="download-txt text-center">

                                    <h2 className="h2-lg">{t("welcomePage.WhatWaiting")}</h2>

                                    <p className="p-lg">
                                        {/*Feugiat eros, ac tincidunt ligula massa in faucibus orci*/}
                                        {/*luctus et*/}
                                        {/*ultrices posuere cubilia curae*/}
                                        {/*integer congue metus mollis lorem primis mollis*/}

                                        {t("welcomePage.WhatWaitingText")}
                                        {/*Загрузите наше приложение и легко начните инспектировать машины. Получите быстрый доступ к необходимой информации и упростите процесс оценки.*/}
                                    </p>

                                    <div className="stores-badge">

                                        <a href="https://www.apple.com/ua/app-store/" className="store">
                                            <img className="appstore-white"
                                                 src={appstoretrawhite}
                                                 width={160} height={50} alt="appstore-logo"/>
                                        </a>

                                        <a href="https://play.google.com/store/games?device=windows&hl=uk"
                                           className="store">
                                            <img className="googleplay-white"
                                                 src={googleplaytrawhite}
                                                 width={160} height={50} alt="googleplay-logo"/>
                                        </a>

                                        <a href="https://chrome.google.com/webstore/category/extensions?hl=uk"
                                           className="store">
                                            <img style={{borderRadius: 5, border: '#cecece 3px solid'}}
                                                 className="googleplay-white"
                                                 src={chromewhite}
                                                 width={170} height={50} alt="googleplay-logo"/>
                                        </a>

                                    </div>

                                </div>
                            </div>


                        </div>
                    </div>
                </section>
                <div>
                </div>
                <Footer/>

            </div>
        </div>

    );
}
export default WelcomePage;
